import { store } from './react-initialize';
import * as HeaderActions from './Header/actions';
import { TopicSelector } from './topic_selector';

export var WorkbenchManager = {
   addItem: function(topicVariantid, wikiid, useIndicator, topicTitle) {
      topicTitle = topicTitle ? topicTitle : null;
      var workbenchTopicContainer = $E('.workbench-topic-container');
      var request = new Request.API_2_0('user/workbench/add?langid=' + App.lang, {
         method: 'POST',
      }).send({
         wikiid: wikiid,
         topicVariantid: topicVariantid,
         topicTitle: topicTitle,
         getWorkbenchHtml: true,
         productcode: App.productcode,
      });

      request.done(function(result) {
         /* Add the html to workbench */
         if (result) {
            if (result.curProductCompatibility) {
               window.location.reload();
            }

            if (typeof result.workbenchHtml != 'undefined' && workbenchTopicContainer) {
               workbenchTopicContainer.appendHTML(result.workbenchHtml, 'top');
               $E('.js-workbench-empty-message').addClass('hidden');
            }

            // With the Hydra header, we're storing the Workbench HTML in
            // Redux so that whenever it changes, the React dropdown can
            // re-render.
            if (typeof result.hydraWorkbenchHtml != 'undefined') {
               store.dispatch(HeaderActions.updateWorkbench(result.hydraWorkbenchHtml));
            }

            if (topicVariantid) {
               WorkbenchManager.removeItem(null, wikiid, /* useIndicator */ false);
            }
         }
         /* Remove variant devices if generic is checked */
         if (!topicVariantid) {
            TopicSelector.deselectVariantItems(wikiid);
         }
      });

      if (useIndicator) {
         LoadingIndicator.withPromise(request, {
            pendingMessage: _js('Adding'),
            successMessage: _js('Added'),
         });
      }
   },

   removeItem: function(topicVariantid, wikiid, useIndicator) {
      var request = new Request.API_2_0('user/workbench/remove?langid=' + App.lang, {
         method: 'POST',
      }).send({
         wikiid: wikiid,
         topicVariantid: topicVariantid,
      });

      request.done(function(response) {
         var item = $('workbench-topic-' + (topicVariantid || wikiid));
         if (item) {
            if ($$('.js-workbench-topic').length <= 1) {
               $E('.js-workbench-empty-message')
                  .removeClass('hidden')
                  .hide()
                  .reveal({
                     duration: 100,
                  });
            }

            item.dissolve({
               duration: 100,
               onComplete: function() {
                  item.dispose();
                  store.dispatch(HeaderActions.updateWorkbench(response.html));
               },
            });
         } else {
            store.dispatch(HeaderActions.updateWorkbench(response.html));
         }
      });

      if (useIndicator) {
         LoadingIndicator.withPromise(request, {
            pendingMessage: _js('Removing'),
            successMessage: _js('Removed'),
         });
      }
   },

   setActiveItem: function(dropdownId) {
      dropdownId = dropdownId.split('-');
      var wikiid = parseInt(dropdownId[0], 10);
      var topicVariantid = dropdownId[1];

      var request = new Request.API_2_0('user/workbench/set_active', {
         method: 'POST',
      }).send({
         wikiid: wikiid,
         topicVariantid: topicVariantid,
      });
   },
};
